import React, { useState, useEffect } from 'react';
import API from '../../utils/api';
import './CoursesView.css';

// Predefined courses removed in favor of dynamic MasterCourses

function CoursesView() {
  const [courses, setCourses] = useState([]);
  const [branches, setBranches] = useState([]);
  const [masterCourses, setMasterCourses] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingCourseId, setEditingCourseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showMasterModal, setShowMasterModal] = useState(false);
  const [newMasterCourse, setNewMasterCourse] = useState('');

  const [formData, setFormData] = useState({
    courseName: '',
    customCourseName: '',
    feeAmount: '',
    status: 'Active'
  });

  useEffect(() => {
    fetchBranches();
    fetchMasterCourses();
  }, []);

  useEffect(() => {
    if (selectedBranchId) {
      fetchCourses(selectedBranchId);
    } else {
      setCourses([]);
    }
  }, [selectedBranchId]);

  const fetchMasterCourses = async () => {
    try {
      const res = await API.get('/api/admin/master-courses');
      setMasterCourses(res.data);
    } catch (err) {
      console.error("Error fetching master courses:", err);
    }
  };

  const fetchBranches = async () => {
    try {
      const res = await API.get('/api/admin/branches');
      setBranches(res.data);
      if (res.data.length > 0) {
        setSelectedBranchId(res.data[0]._id);
      }
    } catch (err) {
      console.error("Error fetching branches:", err);
    }
  };

  const fetchCourses = async (branchId) => {
    setLoading(true);
    try {
      const res = await API.get(`/api/admin/courses?branchId=${branchId}`);
      setCourses(res.data);
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedBranchId) {
      alert("Please select a branch first.");
      return;
    }

    const payload = {
      courseName: formData.courseName === 'Other' ? formData.customCourseName : formData.courseName,
      feeAmount: Number(formData.feeAmount),
      branchId: selectedBranchId,
      status: formData.status
    };

    try {
      if (editMode) {
        await API.put(`/api/admin/courses/${editingCourseId}`, payload);
        alert('Course updated successfully');
      } else {
        await API.post('/api/admin/courses', payload);
        alert('Course added successfully');
      }
      setShowModal(false);
      fetchCourses(selectedBranchId);
    } catch (err) {
      alert(err.response?.data?.message || 'Error saving course');
    }
  };

  const handleEditClick = (course) => {
    setEditMode(true);
    setEditingCourseId(course._id);
    const isPredefined = masterCourses.some(mc => mc.courseName === course.courseName);
    setFormData({
      courseName: isPredefined ? course.courseName : 'Other',
      customCourseName: isPredefined ? '' : course.courseName,
      feeAmount: course.feeAmount,
      status: course.status
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this course?')) {
      try {
        await API.delete(`/api/admin/courses/${id}`);
        fetchCourses(selectedBranchId);
      } catch (err) {
        alert('Failed to delete course');
      }
    }
  };

  const filteredCourses = courses.filter(course =>
    course.courseName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAddMasterCourse = async (e) => {
    e.preventDefault();
    if (!newMasterCourse.trim()) return;
    try {
      await API.post('/api/admin/master-courses', { courseName: newMasterCourse });
      setNewMasterCourse('');
      fetchMasterCourses();
    } catch (err) {
      alert(err.response?.data?.message || 'Error adding master course');
    }
  };

  const handleDeleteMasterCourse = async (id) => {
    if (window.confirm('Are you sure you want to delete this master course?')) {
      try {
        await API.delete(`/api/admin/master-courses/${id}`);
        fetchMasterCourses();
      } catch (err) {
        alert('Failed to delete master course');
      }
    }
  };

  return (
    <div className="admin-view">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
        <h2>Manage Courses</h2>
        
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
          <select 
            value={selectedBranchId} 
            onChange={(e) => setSelectedBranchId(e.target.value)}
            style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc' }}
          >
            <option value="" disabled>Select Branch</option>
            {branches.map(b => (
              <option key={b._id} value={b._id}>{b.branchName}</option>
            ))}
          </select>

          <input 
            type="text" 
            placeholder="Search courses..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
            style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #ccc', minWidth: '200px' }}
          />

          <button 
            className="add-btn" 
            style={{ backgroundColor: '#10b981' }}
            onClick={() => setShowMasterModal(true)}
          >
            ⚙️ Global Courses List
          </button>

          <button 
            className="add-btn" 
            onClick={() => {
              if (!selectedBranchId) {
                alert("Please select a branch first.");
                return;
              }
              setEditMode(false);
              setEditingCourseId(null);
              setFormData({ courseName: '', customCourseName: '', feeAmount: '', status: 'Active' });
              setShowModal(true);
            }}
          >
            + Assign Course to Branch
          </button>
        </div>
      </div>

      <div className="table-container">
        {loading ? (
          <p style={{ textAlign: 'center', padding: '20px' }}>Loading courses...</p>
        ) : courses.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
            <p>No courses found for the selected branch.</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Course Name</th>
                <th>Fee Amount (₹)</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCourses.map(course => (
                <tr key={course._id}>
                  <td style={{ fontWeight: '600' }}>{course.courseName}</td>
                  <td style={{ color: '#0ea5e9', fontWeight: 'bold' }}>{course.feeAmount.toLocaleString('en-IN')}</td>
                  <td>
                    <span className={course.status === 'Active' ? 'status-active' : 'status-inactive'}>
                      {course.status}
                    </span>
                  </td>
                  <td>
                    <button className="action-btn edit-btn" onClick={() => handleEditClick(course)}>Edit</button>
                    <button className="action-btn delete-btn" onClick={() => handleDelete(course._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content small-modal">
            <span className="close-btn" onClick={() => setShowModal(false)}>&times;</span>
            <h3 style={{ marginBottom: '20px', color: '#0284c7' }}>{editMode ? 'Edit Course' : 'Add New Course'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label>Course Name *</label>
                <select 
                  name="courseName" 
                  required 
                  value={formData.courseName} 
                  onChange={handleInputChange}
                >
                  <option value="">-- Select Course --</option>
                  {masterCourses.map(c => (
                    <option key={c._id} value={c.courseName}>{c.courseName}</option>
                  ))}
                  <option value="Other">Other (Type manually)</option>
                </select>
              </div>

              {formData.courseName === 'Other' && (
                <div className="input-group" style={{ marginTop: '15px' }}>
                  <label>Custom Course Name *</label>
                  <input 
                    type="text" 
                    name="customCourseName" 
                    required 
                    value={formData.customCourseName} 
                    onChange={handleInputChange} 
                    placeholder="Enter course name"
                  />
                </div>
              )}

              <div className="input-group" style={{ marginTop: '15px' }}>
                <label>Total Fee Amount (₹) *</label>
                <input 
                  type="number" 
                  name="feeAmount" 
                  required 
                  value={formData.feeAmount} 
                  onChange={handleInputChange} 
                  placeholder="e.g. 25000"
                />
              </div>

              <div className="input-group" style={{ marginTop: '15px' }}>
                <label>Status</label>
                <select name="status" value={formData.status} onChange={handleInputChange}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              <div className="submit-area" style={{ marginTop: '20px' }}>
                <button type="submit" className="submit-btn">{editMode ? 'Update Course' : 'Save Course'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showMasterModal && (
        <div className="modal-overlay">
          <div className="modal-content small-modal">
            <span className="close-btn" onClick={() => setShowMasterModal(false)}>&times;</span>
            <h3 style={{ marginBottom: '20px', color: '#0284c7' }}>Global Master Courses</h3>
            
            <form onSubmit={handleAddMasterCourse} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
              <input 
                type="text" 
                required
                value={newMasterCourse}
                onChange={(e) => setNewMasterCourse(e.target.value)}
                placeholder="New course name..."
                style={{ flex: 1, padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
              />
              <button type="submit" className="add-btn" style={{ padding: '10px 15px' }}>Add</button>
            </form>

            <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '5px' }}>
              <table className="data-table" style={{ margin: 0 }}>
                <thead>
                  <tr>
                    <th>Course Name</th>
                    <th style={{ width: '60px' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {masterCourses.map(mc => (
                    <tr key={mc._id}>
                      <td>{mc.courseName}</td>
                      <td>
                        <button 
                          className="action-btn delete-btn" 
                          style={{ padding: '4px 8px', margin: 0 }}
                          onClick={() => handleDeleteMasterCourse(mc._id)}
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  ))}
                  {masterCourses.length === 0 && (
                    <tr>
                      <td colSpan="2" style={{ textAlign: 'center', padding: '10px' }}>No courses added yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CoursesView;
